import React from 'react';
import { TouchableOpacity, Text, StyleSheet, View, GestureResponderEvent } from 'react-native';
import LinearGradient from 'react-native-linear-gradient';

type TGameButtonProps = {
  label: string;
  active: boolean;
  onPress?: (event: GestureResponderEvent) => void;
};

export default function GameButton(props: TGameButtonProps) {
  const { label, active, onPress } = props;
  return (
    <TouchableOpacity style={styles.wrapper} onPress={onPress}>
      {active ? (
        <LinearGradient
          colors={['#FFD977', '#FFA500']} // gradient for active
          style={styles.activeButton}
        >
          <Text style={styles.activeText}>{label}</Text>
        </LinearGradient>
      ) : (
        <View style={styles.inactiveButton}>
          <Text style={styles.inactiveText}>{label}</Text>
        </View>
      )}
    </TouchableOpacity>
  );
}

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    marginHorizontal: 5,
    borderRadius: 12,
    overflow: 'hidden',
  },
  activeButton: {
    paddingVertical: 15,
    borderRadius: 12,
    alignItems: 'center',
    width: 113,
  },
  inactiveButton: {
    backgroundColor: '#FFE699',
    paddingVertical: 15,
    borderRadius: 12,
    alignItems: 'center',
    width: 113,
  },
  activeText: {
    fontSize: 14,
    fontWeight: '700',
    color: '#121212',
  },
  inactiveText: {
    fontSize: 14,
    fontWeight: '500',
    color: '#121212',
  },
});
